import mainTheme from "@irati/ui/src/global/theme"
import {regularStyles} from "@irati/ui/src/Typography/Input/styles"

const getDropdownColor = (state) => {
  if (state.isDisabled) {
    return mainTheme.colors.greys.mediumLight
  }
  return state.selectProps.menuIsOpen ? mainTheme.colors.greys.white : mainTheme.colors.filterChip
}

// eslint-disable-next-line no-undef
const selectStyles: Styles = {
  container: (base) => ({
    ...base,
    margin: `${mainTheme.spacing.one} 0`
  }),
  control: (base, state) => ({
    ...base,
    border: `1px solid ${state.isFocused ? mainTheme.colors.greys.medium : mainTheme.colors.greys.mediumLight}`,
    borderRadius: mainTheme.spacing.oneAndHalf,
    boxShadow: "none",
    minHeight: 48,
    background: state.selectProps.menuIsOpen ? mainTheme.colors.filterChip : "transparent",
    ":hover": {
      borderColor: mainTheme.colors.greys.medium
    }
  }),
  dropdownIndicator: (base, state) => ({
    ...base,
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none",
    color: getDropdownColor(state),
    ":hover": {
      color: getDropdownColor(state)
    }
  }),
  menu: (base) => ({
    ...base,
    margin: `${mainTheme.spacing.one} 0`,
    boxShadow: mainTheme.shadows.low,
    width: "280px"
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    borderRadius: mainTheme.border.radius
  }),
  option: (base) => ({
    ...base,
    padding: mainTheme.spacing.two,
    ...(regularStyles as any)
  }),
  valueContainer: (base) => ({
    ...base,
    padding: `0 0 0 ${mainTheme.spacing.two}`
  }),
  input: (base, state) => ({
    ...base,
    color: state?.value?.length ? mainTheme.colors.greys.white : mainTheme.colors.filterChip
  })
}

export default selectStyles
